export default __webpack_public_path__ + "40c9a3390e0f4ae30c0fa4cbea35e2bd.wav";